"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withExperiments = exports.ExperimentsProvider = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var wix_experiments_1 = tslib_1.__importDefault(require("@wix/wix-experiments"));
var ExperimentsProvider = /** @class */ (function (_super) {
    tslib_1.__extends(ExperimentsProvider, _super);
    function ExperimentsProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.experiments = new wix_experiments_1.default(props.options);
        return _this;
    }
    ExperimentsProvider.prototype.getChildContext = function () {
        return { experiments: this.experiments };
    };
    ExperimentsProvider.prototype.render = function () {
        return React.Children.only(this.props.children);
    };
    ExperimentsProvider.childContextTypes = {
        experiments: prop_types_1.default.object.isRequired,
    };
    return ExperimentsProvider;
}(React.Component));
exports.ExperimentsProvider = ExperimentsProvider;
function withExperiments(WrappedComponent) {
    var _a;
    return _a = /** @class */ (function (_super) {
            tslib_1.__extends(class_1, _super);
            function class_1(props, context) {
                var _this = _super.call(this, props, context) || this;
                _this.experiments = context.experiments;
                _this.state = { ready: !_this.experiments.pending() };
                _this.experiments
                    .ready()
                    .then(function () { return _this.setState({ ready: true }); })
                    .catch(function () { });
                return _this;
            }
            class_1.prototype.render = function () {
                var extraProps = { experiments: this.experiments };
                if (this.state.ready) {
                    return React.createElement(WrappedComponent, tslib_1.__assign(tslib_1.__assign({}, this.props), extraProps));
                }
                return null;
            };
            return class_1;
        }(React.Component)),
        _a.contextTypes = {
            experiments: prop_types_1.default.instanceOf(wix_experiments_1.default),
        },
        _a;
}
exports.withExperiments = withExperiments;
//# sourceMappingURL=index.js.map